/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { is404Error } from '@zcode/error-filters'
import * as Api from '@zcode/nr/es/shared/api'
import type { Dispatch } from 'redux'
import { logger } from '../../../logger'
import { setProfileShare } from '../actions/index'

export const createProfileShare =
  (keys: readonly string[], listingId: number | null | undefined) => async (dispatch: Dispatch) => {
    const body = {
      expires_after: 30,
      copy_fields: {
        estimated: [],
        explicit: keys,
      },
      listing_id: listingId,
    }
    try {
      const profileShare = await Api.profileShare.save(body)
      dispatch(setProfileShare(profileShare))
    } catch (e) {
      if (!is404Error(e)) {
        logger.error('Failed to create profile share', e)
      }
    }
  }
